package org.catharsis.spendtel.core.network

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

@Serializable
data class ApiErrorResponse(
    val error: String,
    val code: String? = null,
    val message: String? = null,
)

private val apiErrorJson = Json { ignoreUnknownKeys = true }

fun parseApiErrorMessage(
    body: String?,
    fallback: String,
): String {
    if (body.isNullOrBlank()) return fallback

    val parsed = runCatching {
        apiErrorJson.decodeFromString<ApiErrorResponse>(body)
    }.getOrNull() ?: return body

    return when (parsed.code) {
        "BILLING_NOT_CONFIGURED" ->
            "Checkout isn't available yet. Stripe billing still needs to be configured on the server."
        else -> when {
            parsed.error.equals("Failed to create checkout session", ignoreCase = true) ->
                "We couldn't start checkout. Please try again in a moment."
            parsed.message?.isNotBlank() == true -> parsed.message
            parsed.error.isNotBlank() -> parsed.error
            else -> fallback
        }
    }
}
